import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FavoriteIcon from "@mui/icons-material/Favorite";

import "./footer.scss";

const Footer = () => {
    return (
        <Box className="footer textCenter p-2">
            <Typography variant="caption" display="block" color="white">
                version : 0.0.1.1
            </Typography>
            <Typography variant="caption" display="block" color="white">
                AT &copy; {new Date().getFullYear()}
            </Typography>
            <Typography variant="caption" display="block" color="white">
                Made with <FavoriteIcon className="heart" /> by Aniruddha Tonge
            </Typography>
        </Box>
    );
};
export default Footer;
